import { Injectable } from '@angular/core';
import { fromUnitType, fromUnitTypeInBridge } from '@modules/rx-intuitive-teeth-orchestrator/models/intuitive-indication';
import { RxIntuitiveIndicationRulesService } from '@modules/rx-intuitive-teeth-orchestrator/services/rx-intuitive-indication-rules.service';
import { Tooth } from '@modules/teeth-diagram/models/tooth';

@Injectable({ providedIn: 'root' })
export class RxIntuitiveCrownAdditionalInfoRulesService {
	constructor(private readonly intuitiveIndicationRulesService: RxIntuitiveIndicationRulesService) {}

	isAdditionalInfoSupportedForTooth(tooth: Tooth | null | undefined): boolean {
		if (!tooth?.ToothID) {
			return false;
		}

		return this.intuitiveIndicationRulesService.shouldShowToothEditorProperties({
			indicationId:
				tooth.BridgeIndex !== null && tooth.BridgeIndex !== undefined
					? fromUnitTypeInBridge(tooth.ToothInBridgeTypeID)
					: fromUnitType(tooth.UnitTypeID)
		});
	}

	toothHasAdditionalInfoFieldsSet(tooth: Tooth | null | undefined): boolean {
		if (!tooth) {
			return false;
		}

		return !!(
			tooth.PreparationDesignBuccalId ||
			tooth.PreparationDesignLingualId ||
			tooth.MarginDesignBuccalId ||
			tooth.MarginDesignLingualId ||
			tooth.ShadeIncisal ||
			tooth.ShadeGingival
		);
	}

	hasAdditionalInfoButtonSaved(teethFlat: readonly Tooth[], sessionToothIds: readonly number[]): boolean {
		const findEntity = (id: number): Tooth | undefined => teethFlat.find(x => x.ToothID === id);

		return sessionToothIds.some(id => this.toothHasAdditionalInfoFieldsSet(findEntity(id)));
	}
}
